// app/javascript/projects/components/ProjectsDisplay.jsx

import React from 'react';
import { Button } from 'ui'
import UserDisplaySectionContainer from './UserDisplaySectionContainer'
import { useSubscription } from '../../hooks/subscriptions/queries';
import { isOwner, isFreeAccount } from '../../utils/subscriptionUtils';
import { useCurrentUser } from '../../hooks/users/queries';
import { useTeamModal } from '../../hooks/subscriptions/useTeamModal';

function TeamComponent() {
  const { data: subscription } = useSubscription();
  const { data: currentUser } = useCurrentUser();
  const { openTeamModal } = useTeamModal();
  const userIsOwner = isOwner(subscription, currentUser?.id);
  const freeAccount = isFreeAccount(subscription);

  return (
    <div>
        {userIsOwner && !freeAccount &&
          <UserDisplaySectionContainer header="Team">
            <p>
              You have {subscription?.quantity} {subscription?.quantity == 1 ? "teammember" : "teammembers"}
            </p>

            <Button variant='blue' onClick={() => openTeamModal()}>Manage Team</Button>
          </UserDisplaySectionContainer>
        }
    </div>
  );
}

export default TeamComponent;
